import Swal from "sweetalert2";

const ModalError = (error, title, confirmButtonText) =>
  Swal.fire({
    customClass: {
      container: "swal-container",
    },
    title: title || "Error",
    text: error,
    icon: "error",
    confirmButtonText: confirmButtonText || "OK",
    didOpen: () => {
      const container = document.querySelector(".swal2-container");
      if (container) {
        container.style.zIndex = "9999";
      }
    },
  });

export default ModalError;
